import { render, staticRenderFns } from "./relatedGoods.vue?vue&type=template&id=6c587a29"
import script from "./relatedGoods.vue?vue&type=script&lang=js"
export * from "./relatedGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports